<template>
  <div v-if="additionalParameters.length > 0">
    <h2>{{ $t("travelService.additionalParametersList") }}:</h2>
    <v-row>
      <v-col :key="additionalParameter.ordinate" class="pa-2" v-for="additionalParameter of additionalParameters" cols="4">
        <v-text-field :label="additionalParameter.name" readonly filled :value="additionalParameter.value"> </v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "AdminTravelServiceAdditionalParamsPreview",
  props: {
    additionalParameters: { required: true }
  }
};
</script>

<style scoped></style>
